import React from 'react';
import PropTypes from 'prop-types';
import '@blazemeter/bzm-header/dist/bzmheader/app-switcher.iife.js';

const BzmHeaderWrapper = props => {
  return (
    <div id={'bzm-header-wrapper'}>
      <bzm-header
        email={props.email}
        bzm-url={props.bzmUrl}
        active-app="sv"
        disable-status-page-script={props.disableStatusPage}
        path-to-subscription-upgrade={props.pathToSubscriptionUpgrade}
        should-display-subscription={props.shouldDisplaySubscription}
      />
    </div>
  );
};

BzmHeaderWrapper.propTypes = {
  email: PropTypes.string,
  bzmUrl: PropTypes.string,
  disableStatusPage: PropTypes.bool,
  pathToSubscriptionUpgrade: PropTypes.string,
  shouldDisplaySubscription: PropTypes.bool,
};

export default BzmHeaderWrapper;
